import { ControlIcons } from 'owa-control-icons';
import {
    SET_DUE_DATE_COMMAND_ID,
    EDIT_DUE_DATE_COMMAND_ID,
} from 'owa-timestream-asset-sdk-duedates';
import { OpenInNewTabText } from 'owa-locstrings/lib/strings/openinnewtabtext.locstring.json';
import { setDueDateText } from 'owa-locstrings/lib/strings/setduedatetext.locstring.json';
import { editDueDateText } from 'owa-locstrings/lib/strings/editduedatetext.locstring.json';
import {
    moveToBucketText,
    moveFromBucketText,
    removeFromCanvasText,
} from '../components/AssetOptions.locstring.json';
import { RenameTitleText } from 'owa-locstrings/lib/strings/renametitle.locstring.json';
import { retryButtonText } from 'owa-locstrings/lib/strings/retrybuttontext.locstring.json';
import { openDirectionsText } from 'owa-locstrings/lib/strings/opendirections.locstring.json';
import { copyAddressText } from 'owa-locstrings/lib/strings/copyaddress.locstring.json';
import { shareLabel } from 'owa-locstrings/lib/strings/sharelabel.locstring.json';
import { switchTXPText } from 'owa-locstrings/lib/strings/switchtxp.locstring.json';
import { switchOriginalText } from 'owa-locstrings/lib/strings/switchoriginal.locstring.json';
import type AssetCommandDescriptor from './AssetCommandDescriptor';

//This file is for commands common to multiple assets.

export const openInNewWindow: AssetCommandDescriptor = {
    id: 'openInNewWindow',
    iconName: ControlIcons.OpenInNewWindow,
    titleResourceId: OpenInNewTabText,
};

export const renameTitle: AssetCommandDescriptor = {
    id: 'renameTitle',
    iconName: ControlIcons.Edit,
    titleResourceId: RenameTitleText,
};

export const removeFromCanvas: AssetCommandDescriptor = {
    id: 'removeFromCanvas',
    iconName: ControlIcons.RemoveContent,
    titleResourceId: removeFromCanvasText,
};

export const retry: AssetCommandDescriptor = {
    id: 'retry',
    iconName: ControlIcons.Refresh,
    titleResourceId: retryButtonText,
};

export const addToBucket: AssetCommandDescriptor = {
    id: 'addToBucket',
    iconName: ControlIcons.Forward,
    iconNameRTL: ControlIcons.Back,
    titleResourceId: moveToBucketText,
};

export const removeFromBucket: AssetCommandDescriptor = {
    id: 'removeFromBucket',
    iconName: ControlIcons.Forward,
    iconNameRTL: ControlIcons.Back,
    titleResourceId: moveFromBucketText,
};

export const setDueDate: AssetCommandDescriptor = {
    id: SET_DUE_DATE_COMMAND_ID,
    iconName: ControlIcons.Clock,
    titleResourceId: setDueDateText,
};

export const editDueDate: AssetCommandDescriptor = {
    id: EDIT_DUE_DATE_COMMAND_ID,
    iconName: ControlIcons.Clock,
    titleResourceId: editDueDateText,
};

export const copyAddress: AssetCommandDescriptor = {
    id: 'copyAddress',
    iconName: ControlIcons.Copy,
    titleResourceId: copyAddressText,
};

export const openDirections: AssetCommandDescriptor = {
    id: 'openDirections',
    iconName: ControlIcons.OpenInNewWindow,
    titleResourceId: openDirectionsText,
};

export const switchTXP: AssetCommandDescriptor = {
    id: 'switchTXP',
    iconName: ControlIcons.View,
    titleResourceId: switchTXPText,
};

export const switchOriginal: AssetCommandDescriptor = {
    id: 'switchOriginal',
    iconName: ControlIcons.Hide3,
    titleResourceId: switchOriginalText,
};

export const share: AssetCommandDescriptor = {
    id: 'share',
    iconName: ControlIcons.PeopleAdd,
    titleResourceId: shareLabel,
};
